<template>
    <PopupRouterViewDetail label="Company Info Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Company Info" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-company-name" label-cols-lg="12"  label="Company Name" label-for="input-company-name" size="sm" :model.sync="model.companyName" :isRequired="true" :state="validateState('companyName')" :errorMessage="getErrorMessage(errorMessage.companyName, 'companyName')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-corporate-field" label-cols-lg="12"  label="Corporate Field" label-for="input-corporate-field" size="sm" :model.sync="model.corporateField" :isRequired="true" :state="validateState('corporateField')" :errorMessage="getErrorMessage(errorMessage.corporateField, 'corporateField')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-company-address" label-cols-lg="12"  label="Company Address" label-for="input-company-address" size="sm" :model.sync="model.companyAddress" :isRequired="true" :state="validateState('companyAddress')" :errorMessage="getErrorMessage(errorMessage.companyAddress, 'companyAddress')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-office-phone-number" label-cols-lg="12"  label="Office Phone Number" label-for="input-office-phone-number" size="sm" :model.sync="model.officePhoneNumber" :isRequired="true" :state="validateState('officePhoneNumber')" :errorMessage="getErrorMessage(errorMessage.officePhoneNumber, 'officePhoneNumber')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-office-fax" label-cols-lg="12"  label="Office Fax" label-for="input-office-fax" size="sm" :model.sync="model.officeFax" :isRequired="true" :state="validateState('officeFax')" :errorMessage="getErrorMessage(errorMessage.officeFax, 'officeFax')"  @change="updateData"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import CompanyInfo from '@/models/CompanyInfo/CompanyInfo';
import CompanyInfoList from '@/models/CompanyInfo/CompanyInfoList';
import CompanyInfoFilter from '@/filters/CompanyInfo/CompanyInfoFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			companyName: {required},
			corporateField: {required},
			companyAddress: {required},
			officePhoneNumber: {required},
			officeFax: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				companyName: { required : "Company Name is Required."},
				corporateField: { required : "Corporate Field is Required."},
				companyAddress: { required : "Company Address is Required."},
				officePhoneNumber: { required : "Office Phone Number is Required."},
				officeFax: { required : "Office Fax is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterCompanyInfo : null,
			currentCompanyInfoPage : 1,
			companyInfoPageSize: 10,
			sortByCompanyInfo: '',
			sortDescCompanyInfo: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getCompanyInfo : async function(id) {
			this.isBusy = true;
			CompanyInfo.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadCompanyInfo = true;
			this.filterCompanyInfo.id = this.modelId;
			CompanyInfo.downloadDataDetail(this, this.filterCompanyInfo).then(result => {
				this.isDownloadCompanyInfo = false;
			}).catch(error => { this.isDownloadCompanyInfo = false; })
		},
		getCompanyInfos : async function(input) {
			let filter = new CompanyInfoFilter();
			if (input != undefined) {
				filter.CompanyName = input;
			}
			this.isCompanyInfoComboLoading = true;
			CompanyInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.companyInfos = result.data
				}
				this.isCompanyInfoComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.companyInfoInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						CompanyInfo.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'companyinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						CompanyInfo.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'companyinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					CompanyInfo.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getCompanyInfo(id);
					});
				}
			});
		},
		onHidden() {
			this.getCompanyInfos();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterCompanyInfo = new CompanyInfoFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getCompanyInfo(id);
			} else {
				this.modelId = id;
				this.getCompanyInfo(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
